export default "__VITE_ASSET__BIk4Mkc9__"